module.exports = __webpack_public_path__ + "img/asterisk.ddeb3650.svg";